/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Client,
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReadOnlyMonitoredObjectGroupNested
 */
export interface ReadOnlyMonitoredObjectGroupNested {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    color?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    monitoredObjectGroupType?: number | null;
    /**
     * 
     * @type {Client}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    client?: Client;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    readonly deleted?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    automaticVehicleAdd?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    readonly deletable?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    readonly monitoredObjects?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReadOnlyMonitoredObjectGroupNested
     */
    readonly users?: Array<number>;
}

export function ReadOnlyMonitoredObjectGroupNestedFromJSON(json: any): ReadOnlyMonitoredObjectGroupNested {
    return ReadOnlyMonitoredObjectGroupNestedFromJSONTyped(json, false);
}

export function ReadOnlyMonitoredObjectGroupNestedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyMonitoredObjectGroupNested {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'monitoredObjectGroupType': !exists(json, 'monitored_object_group_type') ? undefined : json['monitored_object_group_type'],
        'client': !exists(json, 'client') ? undefined : ClientFromJSON(json['client']),
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'automaticVehicleAdd': !exists(json, 'automatic_vehicle_add') ? undefined : json['automatic_vehicle_add'],
        'deletable': !exists(json, 'deletable') ? undefined : json['deletable'],
        'monitoredObjects': !exists(json, 'monitored_objects') ? undefined : json['monitored_objects'],
        'users': !exists(json, 'users') ? undefined : json['users'],
    };
}

export function ReadOnlyMonitoredObjectGroupNestedToJSON(value?: ReadOnlyMonitoredObjectGroupNested | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'color': value.color,
        'monitored_object_group_type': value.monitoredObjectGroupType,
        'client': ClientToJSON(value.client),
        'automatic_vehicle_add': value.automaticVehicleAdd,
    };
}


